import _, { isEmpty } from "lodash";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { setAssign, setDisableBtn, setIsLoading, setMediaIdReset, toggleDialog } from "../redux/Slices/Global/globalSlice";
import { setIsPublished } from "../redux/Slices/layoutSlice";
import { handleResErrors, useInvalidateCampaignLayer } from "./utils";
import { useCustomToast } from "../pages/Contexts/ToastContext";
import axiosInstance from "../config/Axios";

//--------------------------Get Campaign By ID--------------------------
const addCampaignContent = async (payload) => {
    const { data } = await axiosInstance.post(`/campaign/content/assign`, payload);
    return data.data;
}

export const useAddCampaignContent = () => {
    const invalidateCampaignLayer = useInvalidateCampaignLayer();
    const { showToast } = useCustomToast();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return useMutation(addCampaignContent, {
        onMutate: () => {
            dispatch(setIsLoading(true))
        },
        onSuccess: async (result, variables) => {
            dispatch(setDisableBtn(false));
            dispatch(setAssign(false))

            let rejectedSatellite = result?.rejected?.satellite;

            var errorsArr = [];

            if (!isEmpty(rejectedSatellite)) {
                let msg = `${rejectedSatellite.map((name) => '"' + name + '" ')} don't support  satellite!`;
                errorsArr.push({ severity: 'error', summary: 'Assign PlayList', detail: msg, life: 3000 });
            }

            if (!isEmpty(errorsArr)) {
                errorsArr.map((error) => { showToast(error.severity, error.summary, error.detail) })
            } else {
                showToast('success', t('addcontent.title'), result?.msg || t('addcontent.added_success'));
                dispatch(setMediaIdReset(result?.toRefetch))
                dispatch(toggleDialog("addContent"))
                invalidateCampaignLayer(variables);
            }

            // dispatch(setIsLoading(false))

        },
        onError: (error) => {
            dispatch(setIsLoading(false))
            handleResErrors(error, showToast)
        }
    })
}

//--------------------------Order Campaign Content--------------------------
const orderCampaignContent = async (payload) => {
    const { data } = await axiosInstance.put(`campaign/content/order`, payload);
    return data.data;
}

export const useOrderCampaignContent = () => {
    const { showToast } = useCustomToast();
    const invalidateCampaignLayer = useInvalidateCampaignLayer();

    const dispatch = useDispatch()
    return useMutation(orderCampaignContent, {
        onMutate: () => {
            dispatch(setIsLoading(true))
        },
        onSuccess: async (result, variables) => {
            invalidateCampaignLayer(variables);
            // showToast('success', 'Campaign', "The campaign has been reordered successfully!");
            // dispatch(setIsLoading(false))

        },
        onError: (error) => {
            handleResErrors(error, showToast)
            dispatch(setIsLoading(false))


        }
    })
}

//--------------------------Update Campaign's Media Thumb --------------------------
const updateInteractiveMedia = async (payload) => {
    const { data } = await axiosInstance.post(`/media/interactive/${payload.id}/update`, payload.data);
    return data.data;
}

export const useUpdateInteractiveMedia = () => {
    const { showToast } = useCustomToast();
    const invalidateCampaignLayer = useInvalidateCampaignLayer();

    const dispatch = useDispatch()
    return useMutation(updateInteractiveMedia, {
        onMutate: () => {
            dispatch(setIsLoading(true))
        },
        onSuccess: async (result, variables) => {
            invalidateCampaignLayer(variables)
            // showToast('success', 'Media  Editing', "Media updated successfully!");
            // dispatch(setIsLoading(false))

        },
        onError: (error) => {
            dispatch(setIsLoading(false))
            handleResErrors(error, showToast)
        }
    })
}

//--------------------------Delete Campaign Content --------------------------
const deleteCampaignContent = async (payload) => {
    const { data } = await axiosInstance.delete(`/campaign/content/${payload.id}/delete`);
    return data.data;
}

export const useDeleteCampaignContent = () => {
    const { showToast } = useCustomToast();
    const invalidateCampaignLayer = useInvalidateCampaignLayer();
    const dispatch = useDispatch()

    return useMutation(deleteCampaignContent, {
        onMutate: () => {
            dispatch(setIsLoading(true))
        },
        onSuccess: async (result, variables) => {
            invalidateCampaignLayer(variables)
            // dispatch(setIsLoading(false))

        },
        onError: (error) => {
            dispatch(setIsLoading(false))
            handleResErrors(error, showToast)
        }
    })
}

//--------------------------Duplicate Campaign Content --------------------------
const duplicateCampaignContent = async (payload) => {
    const { data } = await axiosInstance.post(`/campaign/content/duplicate`, payload);
    return data.data;
}

export const useDuplicateCampaignContent = () => {
    const { showToast } = useCustomToast();
    const invalidateCampaignLayer = useInvalidateCampaignLayer();
    const dispatch = useDispatch()
    return useMutation(duplicateCampaignContent, {
        onMutate: () => {
            dispatch(setIsLoading(true))
        },
        onSuccess: async (result, variables) => {
            invalidateCampaignLayer(variables)
            // dispatch(setIsLoading(false))

            // showToast('success', 'Media Duplicated', result?.msg);

        },
        onError: (error) => {
            dispatch(setIsLoading(false))
            handleResErrors(error, showToast)
        }
    })
}


//--------------------------Update Campaign's Media Duration --------------------------
const updateMediaDuration = async (payload) => {
    const { data } = await axiosInstance.put(`/campaign/playlist-media/${payload.id}/update`, payload?.data);
    return data.data;
}

export const useUpdateMediaDuration = () => {
    const invalidateCampaignLayer = useInvalidateCampaignLayer();
    const { showToast } = useCustomToast();
    const dispatch = useDispatch()
    return useMutation(updateMediaDuration, {
        onMutate: () => {
            dispatch(setIsLoading(true))
        },
        onSuccess: async (result, variables) => {

            invalidateCampaignLayer(variables)
            // showToast('success', 'Retrieve Media duration', result?.msg);
        },
        onError: (error) => {
            dispatch(setIsLoading(false))
            handleResErrors(error, showToast)
        }
    })
}

//--------------------------Retrieve Campaign's Media Duration --------------------------
const retrieveMediaDuration = async (payload) => {
    const { data } = await axiosInstance.put(`/campaign/media/${payload.id}/duration`, {});
    return data.data;
}

export const useRetrieveMediaDuration = () => {
    const invalidateCampaignLayer = useInvalidateCampaignLayer();
    const { showToast } = useCustomToast();

    return useMutation(retrieveMediaDuration, {
        onSuccess: async (result, variables) => {
            invalidateCampaignLayer(variables)
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}

//--------------------------Retrieve new Media Duration --------------------------
const retrieveNewMediaDuration = async (payload) => {
    const { data } = await axiosInstance.put(`/campaign/media/${payload.id}/duration/new`, {});
    return data.data;
}

export const useRetrieveNewMediaDuration = () => {
    const invalidateCampaignLayer = useInvalidateCampaignLayer();
    const { showToast } = useCustomToast();

    return useMutation(retrieveNewMediaDuration, {
        onSuccess: async (result, variables) => {
            invalidateCampaignLayer(variables)
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}

//--------------------------Update Campaign's Content Setting --------------------------
const updateCampaignContentSettings = async (payload) => {
    const { data } = await axiosInstance.post(`/campaign/media/${payload.id}/setting`, payload.data);
    return data.data;
}

export const useUpdateCampaignContentSettings = () => {
    const invalidateCampaignLayer = useInvalidateCampaignLayer();
    const { showToast } = useCustomToast();
    const dispatch = useDispatch();

    return useMutation(updateCampaignContentSettings, {
        onMutate: () => {
            dispatch(setIsLoading(true))
        },
        onSuccess: async (variables) => {
            if (!variables.suppressDialog) {
                if (variables.type == "playlist") {
                    dispatch(toggleDialog("playlistSettingPopup"))
                } else {
                    dispatch(toggleDialog("mediaSettingPopup"))
                }
            }
            // Mark layout as unpublished so the user can publish changes
            dispatch(setIsPublished(false));

            invalidateCampaignLayer(variables)
            // showToast('success', 'Media Setting', "Campaign's media updated successfully!");
        },
        onError: (error) => {
            handleResErrors(error, showToast)
            dispatch(setIsLoading(false))

        }
    })
}


//--------------------------Update Campaign  Layer Settings Layer Settings Layer Settings Layer Settings Layer Settings --------------------------


const updateCampaignLayerSettings = async ({ id, layer, layer_settings }) => {
    const payload = layer ? { layer, layer_settings } : { layer_settings };
    const { data } = await axiosInstance.patch(`/campaign/update/${id}/layer`, payload);
    return data;
};

export const useUpdateCampaignLayerSettings = () => {
    const queryClient = useQueryClient();
    const invalidateCampaignLayer = useInvalidateCampaignLayer();
    const { showToast } = useCustomToast();
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: updateCampaignLayerSettings,

        // Optimistic update
        onMutate: async (vars) => {
            dispatch(setIsLoading(true));
            const { id, layer, layer_settings } = vars;

            // Snapshot previous cache
            const prevCampaign = queryClient.getQueryData(['campaign', id]);

            // Try to optimistically merge into cached campaign
            if (prevCampaign) {
                const next = structuredClone(prevCampaign);
                const live = next?.settings?.live ?? (next.settings = { ...(next.settings || {}), live: {} }, next.settings.live);
                live.layer_settings = live.layer_settings || {};

                if (layer) {
                    // single-layer: merge into the specific layer
                    const current = live.layer_settings[layer] || {};
                    live.layer_settings[layer] = {
                        ...current,
                        ...(layer_settings || {}),
                        settings: { ...(current.settings || {}), ...(layer_settings?.settings || {}) },
                    };
                } else if (layer_settings && typeof layer_settings === 'object') {
                    // bulk: merge layer by layer
                    Object.entries(layer_settings).forEach(([L, obj]) => {
                        const current = live.layer_settings[L] || {};
                        live.layer_settings[L] = {
                            ...current,
                            ...(obj || {}),
                            settings: { ...(current.settings || {}), ...(obj?.settings || {}) },
                        };
                    });
                }

                queryClient.setQueryData(['campaign', id], next);
            }

            return { prevCampaign, id, layer, layer_settings };
        },

        onError: (error) => {
            handleResErrors(error, showToast);
            dispatch(setIsLoading(false));
        },

        onSuccess: (res, vars) => {
            invalidateCampaignLayer({ id: vars.id });
            dispatch(toggleDialog('layerSettings'))
        },


    });
};

